import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store';
import { VueMaskDirective } from 'v-mask'
import VueAxios from 'vue-axios';
import axios from 'axios';
import ApiService from '@/services/api.service';
import VueRouter from 'vue-router';
import VueGtag from "vue-gtag";
import {InlineSvgPlugin} from 'vue-inline-svg';

Vue.use(VueGtag, {
  config: { id: "AW-719993565" } 
});
Vue.use(InlineSvgPlugin);
Vue.use(VueRouter)
Vue.use(VueAxios, axios);
Vue.directive('mask', VueMaskDirective);
Vue.config.productionTip = false
ApiService.init();
import router from './router'
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
